import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-s7 text-muted" }

import { useUtils, setNestedDialogOpen } from '@/composables/utils/useUtils';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoWalletModal',
  props: {
    modelValue: { type: Boolean },
    name: null,
    link: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  name: string;
  link?: string;
}




const { openExternalLink } = useUtils();
const onShow = () => {
  setNestedDialogOpen(true);
};
const onHide = () => {
  setNestedDialogOpen(false);
  emits('update:modelValue', false);
};
const isDialog = computed({
  get: () => props.modelValue,
  set: value => emits('update:modelValue', value),
});
const onCloseDialog = () => {
  isDialog.value = false;
  onHide();
};
const onInstallWallet = () => {
  openExternalLink(props.link);
  onCloseDialog();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _unref(isDialog),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDialog) ? (isDialog).value = $event : null)),
    ref: "noWallet",
    modal: true,
    dismissableMask: "",
    draggable: false,
    "close-on-escape": "",
    header: _ctx.$t('noWalletModal.extensionNotFound'),
    onShow: onShow,
    onHide: onHide,
    class: "p-confirm-dialog"
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.name) + " " + _toDisplayString(_ctx.$t('noWalletModal.description')), 1)
    ]),
    _: 2
  }, [
    (__props.link)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              label: `${_ctx.$t('noWalletModal.install')} ${__props.name}`,
              onClick: onInstallWallet,
              class: "button-primary w-full"
            }, null, 8, ["label"])
          ])
        }
      : undefined
  ]), 1032, ["visible", "header"]))
}
}

})